<template>
  <div id="cyclic-list">
    <v-dialog
            v-model="dialog"
            max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{$t('cyclic.uare_sure')}}</v-card-title>

        <v-card-text>
          {{$t('cyclic.delete_def_info')}}
        </v-card-text>
        <v-card-text>
          {{$t('cyclic.delete_def_info_sec')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                  color="green darken-1"
                  text
                  @click="dialog = false"
          >
            {{$t('cyclic.abort')}}
          </v-btn>
          <v-btn
                  color="green darken-1"
                  text
                  @click="deleteItem()"
          >
            {{$t('cyclic.confirm_delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-app id="inspire">
        <div>
        <v-btn  @click="create" color="primary" dark class="mb-2">{{ $t('cyclic.create.new_cyclic') }}</v-btn>

          <v-data-table
            :headers="headers"
            :items="cyclics"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td class="text-xs">{{ props.item.interval }}</td>
              <td class="text-xs">{{ props.item.status ==10 ? `${$t('user.status-type.active')}` : `${$t('user.status-type.inactive')}` }}</td>

              <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="viewItem(props.item)">
                  <v-icon color="green darken-3">pageview</v-icon>
                </v-btn>

                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon     color="blue darken-3">edit</v-icon>
                </v-btn>

                <v-btn icon class="mx-0" @click="prepareToDelete(props.item)">
                  <v-icon color="black darken-3">delete</v-icon>
                </v-btn>

              </td>

            </template>

            <template slot="no-data">
              <v-btn color="primary" @click="loadCyclic">Reset</v-btn>
            </template>
          </v-data-table>
        </div>
      </v-app>
  </div>
</template>

<script>
import http from '@/plugins/http'

export default {
  components: {
  },
  data: () => ({
    cyclics:[],
    dialog:false,
    cyclicToDelete:{}
  }),

  computed: {
    headers(){
      return  [
        { text: this.$t("cyclic.create.new_cyclic"),align: 'left',sortable: false,value: 'name'},
        { text: this.$t("cyclic.interval"), value: 'interval' },
        { text: this.$t("cyclic.create.status"), value: 'status' },
      ]
    }
  },

  watch: {
  },
  created () {
    this.loadCyclic();
  },

  methods: {
    viewItem (item) {
      this.$router.push({'path':'/cyclic/view/'+item.id})
    },
    prepareToDelete(item){
      this.cyclicToDelete=item
      this.dialog=true
    },
    deleteItem () {
      http.delete('cyclic/' + this.cyclicToDelete.id).then(()=>this.cyclics=this.cyclics.filter((el)=>el.id!=this.cyclicToDelete.id))
      this.dialog=false;
    },
    editItem (item) {
      this.$router.push({"path":"/cyclic/edit/" + item.id})
    },

    create(){
      this.$router.push({"path":"/cyclic"})
    },
    loadCyclic(){
      this.loading = true
      http.get('cyclics')
          .then(response => {
          this.cyclics = response.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>

</style>
